import ReactDom from "react-dom";
import PrimaryNav from "./PrimaryNav/PrimaryNav.jsx";

export default function renderPrimaryNav(store) {
  document.querySelectorAll(".js-primary-nav-mount").forEach((mount) => {
    const navItems = JSON.parse(mount.getAttribute("data-nav-items"));
    const search = JSON.parse(mount.getAttribute("data-search"));
    const dataExplorer = JSON.parse(mount.getAttribute("data-explorer"));
    const reportState = store.getState();

    const render = (state) =>
      ReactDom.render(
        <PrimaryNav
          navItems={navItems}
          search={search}
          dataExplorer={dataExplorer}
          draftReport={state.draftReport}
        />,
        mount,
      );
    store.subscribe(render);
    render(reportState);
  });
}
